export default __webpack_public_path__ + "static/blob2-d9ef75b2977714617122f777893f4074.svg";